import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingSection } from './components/ClosingSection';
import { FAQ } from './components/FAQ';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Hero } from './components/Hero';
import { LookInsideCarousel } from './components/LookInsideCarousel';
import { MetaPixel } from './components/MetaPixel';
import { ModulesSection } from './components/ModulesSection';
import { PricingSection } from './components/PricingSection';
import { ProblemSection } from './components/ProblemSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { SummaryTable } from './components/SummaryTable';
import { SystemSection } from './components/SystemSection';
import { UrgencySection } from './components/UrgencySection';
import { productShortName } from './data/offer';
const pageDescription = 'A visual technical reference to cement and concrete technology, from the raw meal to the finished structure. 6 professional volumes, 5 exclusive bonuses and instant access.';
export function App() {
  useEffect(() => {
    document.title = productShortName;
    const setMeta = (attr: 'name' | 'property', key: string, content: string) => {
      let tag = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute(attr, key);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('name', 'description', pageDescription);
    setMeta('property', 'og:title', productShortName);
    setMeta('property', 'og:description', pageDescription);
  }, []);
  return <div className="min-h-screen w-full overflow-hidden bg-background font-sans text-muted antialiased" data-id="element-0" data-mp="nuraocvicv35">
      <MetaPixel data-id="element-1" data-mp="st2iki28sviq" />
      <main data-id="element-2" data-mp="swqajcs1h9vc">
        <Hero data-id="element-3" data-mp="36hwt7ylgu1r" />
        <LookInsideCarousel data-id="element-4" data-mp="3686fj9n0kvj" />
        <ProblemSection data-id="element-5" data-mp="35ghusegjner" />
        <SystemSection data-id="element-6" data-mp="34nc9ur8j3y7" />
        <ModulesSection data-id="element-7" data-mp="3uct43lu76r1j" />
        <BonusSection data-id="element-8" data-mp="3udazkg91d18e" />
        <UrgencySection data-id="element-9" data-mp="3ubzrw5cgz9c0" />
        <PricingSection data-id="element-10" data-mp="3uevrdy3yu62k" />
        <GuaranteeSection data-id="element-11" data-mp="d4nuteha5g1c" />
        <FAQ data-id="element-12" data-mp="d4xpvgh6mddw" />
        <ClosingSection data-id="element-13" data-mp="d3cuxpqygsfi" />
        <SummaryTable data-id="element-14" data-mp="d3waizt4v4qd" />
        <FinalCta data-id="element-15" data-mp="85l1usekr09q" />
      </main>
      <Footer data-id="element-16" data-mp="85bc95xfyv4k" />
      <PurchaseNotification data-id="element-17" data-mp="86w58r43y60b" />
    </div>;
}